import type { City } from "app/features/regional-map/regional-map.types"

export function dollarFormat(value: number) {
  const M = 1000000
  if (value >= M) {
    return `${(value / M).toLocaleString("en", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} million`
  }
  return value.toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })
}

export function formatNumber(x: number): string {
  return new Intl.NumberFormat("en-us").format(Math.round(x))
}

export function roundToNearestThousand(value: number): string {
  return (Math.round(value / 1000) * 1000).toLocaleString("en")
}

export function localeWithDecimals(value: number): string {
  return value.toLocaleString("en", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
}

export const formatNumberWithPostfix = (num: number): string => {
  const numStr = num + ""
  const lastDigit = num % 10
  const secondLastDigit = num % 100

  if (secondLastDigit >= 11 && secondLastDigit <= 13) {
    return numStr + "th"
  }

  switch (lastDigit) {
    case 1:
      return numStr + "st"
    case 2:
      return numStr + "nd"
    case 3:
      return numStr + "rd"
    default:
      return numStr + "th"
  }
}

export function updateText(text: string, city: City) {
  if (city.id === "toronto") {
    text = text.replace(/neighborhood/g, "neighbourhood")
    text = text.replace(/urban/g, "")
    text = text.replace(/and state/g, "")
  }
  return text
}

const PR_RESIDENT_COMMISSIONER_DISTRICT = "PR Resident Commissioner District (at Large)"

export const translateCongressionalDistrictName = (name: string, t?: (key: string) => string) => {
  if (name === PR_RESIDENT_COMMISSIONER_DISTRICT) {
    return t ? t("common:resident_commissioner_district_at_large") : name
  }
  return name
}

export const formatCongressionalDistrictName = (name: string, t?: (key: string) => string) => {
  const districtNumber = getDistrictNumber(name)
  if (districtNumber === 0) return translateCongressionalDistrictName(name, t)
  return formatNumberWithPostfix(districtNumber)
}

export const isValidNumber = (str: string) => {
  return !isNaN(parseFloat(str))
}

export const getDistrictNumber = (name: string) => {
  const nameSplit = name.split(" ")
  const districtNumber = nameSplit[nameSplit.length - 1]
  if (!isValidNumber(districtNumber ?? "")) return 0
  return parseInt(districtNumber!)
}
